module.exports = __webpack_public_path__ + "static/media/20s_male_actors_cass_braido.85b849d7.jpg";